import React,{ useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import api from "../api";

const useStoreSetupCheck = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [setupStatus, setSetupStatus] = useState({
        subscription: false,
        payment: false,
        delivery: false,
        product: false,
        mobile: false,
    });

    useEffect(() => {
        const fetchSetupStatus = async () => {
            try {
                const token = localStorage.getItem("access_token");
                const response = await api.get("/vendor/store-setup-status/", {
                    headers: { Authorization: `Bearer ${token}` },
                });

                    const data = response.data;

                    if (!data || Object.keys(data).length === 0) {
                        return;
                    }

                    setSetupStatus(data);

                    if (
                        data.delivery === false ||
                        data.mobile === false
                    ) {
                        if (location.pathname !== "/seller/setup") {
                            navigate("/seller/setup", { replace: true });
                        }
                    }
            } catch (error) {
                //console.error("Error fetching setup status:", error);
            }
        };

        fetchSetupStatus();
    }, []);

    return setupStatus;
};

export default useStoreSetupCheck;
